import { constants } from "../constants";
import { StringFormat } from "../Util/stringutil";
import {
  DepartmentResult,
  InsertDepartmentRequest,
  InsertDepartmentResponse,
} from "./entity/DepartmentOperationEntity";
import { Status } from "./entity/Status";
import { myFetch } from "./myFetch";

// Interface for the Corporation API calls...
export default interface IDepartmentOperation {
  getDepartmentByAsync(
    corpId: number,
    branchId: number
  ): Promise<DepartmentResult>;

  postDepartmentAsync(
    corpId: number,
    branchId: number,
    department: InsertDepartmentRequest
  ): Promise<Status<InsertDepartmentResponse>>;
}

export class DepartmentOperation implements IDepartmentOperation {
  async postDepartmentAsync(
    corpId: number,
    branchId: number,
    department: InsertDepartmentRequest
  ): Promise<Status<InsertDepartmentResponse>> {
    const response = await myFetch<Status<InsertDepartmentResponse>>(
      `${constants.BASE_URL}${StringFormat(
        constants.POST_DEPARTMENT,
        corpId,
        branchId
      )}`,
      {
        method: "POST",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify(department),
      }
    );

    const data = await response.json();
    return data;
  }
  // Get Corpration detail by Id..
  async getDepartmentByAsync(
    corpId: number,
    branchId: number
  ): Promise<DepartmentResult> {
    const response = await myFetch<DepartmentResult>(
      `${constants.BASE_URL}${StringFormat(
        constants.GET_BRANCH_DEPARTMENT,
        corpId,
        branchId
      )}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: ``,
        }),
      }
    );

    const data = await response.json();
    return data;
  }
}
